import { Navigate, Link } from "react-router";
import Markdown from "react-markdown";
import CharacterCard from "../components/character_card";
import CHARACTERS from "../characters";
import t from "../locales";

export default function Characters({ response }) {
  if (!response.getAnswer("groupCode")) return <Navigate replace to="/" />;

  return (
    <article className="card card--characters">
      <title>{t("characters.page-title")}</title>
      <div className="card__header">
        <h1 className="card__title">
          {t("characters.title")
            .split(/{{(\w+)}}/)
            .map((part, i) =>
              i % 2 ? (
                <span key={part} className="card__name" data-character={part}>
                  {t(["characters", "names", part])}
                </span>
              ) : (
                part
              ),
            )}
        </h1>
        <div className="card__description markdown">
          <Markdown>{t("characters.description")}</Markdown>
        </div>
      </div>
      <div className="characters">
        {CHARACTERS.map(({ key, photo }) => (
          <CharacterCard key={key} characterKey={key} photo={photo} />
        ))}
      </div>
      <Link to={`/analyse/${CHARACTERS[0].key}`} className="button">
        {t("characters.start")}
      </Link>
    </article>
  );
}
